import { useState } from "react";

export default function useModalState(initialData = null) {
  const [state, setState] = useState({
    isOpen: false,
    data: initialData,
  });

  const open = (data = initialData) => {
    setState({
      isOpen: true,
      data,
    });
  };

  const close = () => {
    setState((current) => ({
      ...current,
      isOpen: false,
    }));
  };

  const update = (nextData) => {
    setState((current) => ({
      ...current,
      data:
        typeof nextData === "function" ? nextData(current.data) : nextData,
    }));
  };

  return {
    ...state,
    open,
    close,
    update,
    setState,
  };
}
